$('.locations select').on('change', function(e) {
    $(e.currentTarget).parents('form').submit();
});
